import { takeLatest, takeEvery } from 'redux-saga/effects';
import _ from 'lodash';

import { fetchRolesRoutine, saveRoleRoutine, removeRoleRoutine } from '../routines';

import { saveSaga, fetchSaga, removeSaga } from './helper';
import { getAccountPath } from '../../utils/firebase';
import { post, put } from '../../utils/request';

function* watchFetchRolesSaga() {
  yield takeLatest(fetchRolesRoutine.TRIGGER, fetchSaga(fetchRolesRoutine, () => getAccountPath('/roles')));
}

function* watchSaveRoleSaga() {
  yield takeEvery(saveRoleRoutine.TRIGGER, saveSaga(saveRoleRoutine,
    (payload) => getAccountPath('roles', payload.values.get('id')),
    (payload) => payload.values.get('id') ? put : post,
    (payload) => _.pick(payload.values.toJS(), ['name'])));
}

function* watchRemoveRoleSaga() {
  yield takeLatest(removeRoleRoutine.TRIGGER, removeSaga(removeRoleRoutine, (role) => getAccountPath(`/roles/${role.id}`)));
}

export {
  watchFetchRolesSaga,
  watchSaveRoleSaga,
  watchRemoveRoleSaga,
};



// WEBPACK FOOTER //
// ./src/redux/sagas/roles.js